export default __webpack_public_path__ + "static/media/botany-logo.50e5fb4c.png";